<!-- 翻车机作业环节明细 -->
<template>
  <dev>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange" :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
    </avue-crud>
    <SelectWagonTipplerOperationRecordList ref="selectWagonTipplerOperationRecord" @replace="replace"></SelectWagonTipplerOperationRecordList>
  </dev>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import {getList, add, update, remove, getDetail} from "./api";
import {searchTimeConfig} from "@/basic-common/util/common";
import SelectWagonTipplerOperationRecordList from "./components/select-operation-record-list.vue"

export default {
  components: {SelectWagonTipplerOperationRecordList},
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: {getList, add, update, remove, getDetail},
      infoCardData: [], // 卡片数据
      option: {
        ...this.$store.state.publicOption,
        column: [
          {
            label: '作业编号',
            prop: 'operationNo',
            search: true, // 查询是否显示
            rules: [
              {required: true, message: '请录入作业编号', trigger: 'blur'}
            ],
            remote: true,
            readonly: true,
            click: () => {
              this.$refs.selectWagonTipplerOperationRecord.open()
            },
          },
          {
            label: '环节类型',
            prop: 'phaseType',
            type: 'select',
            overHidden: true,
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=phase_type",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择环节类型', trigger: 'change'}
            ],
            value: 1
          },
          {
            label: '环节名称',
            prop: 'phaseName',
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=phase_name",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择环节名称', trigger: 'change'}
            ],
          },
          {
            label: '环节顺序',
            prop: 'phaseOrder',
            type: 'number',
            search: false,
            rules: [
              {required: true, message: '请输入环节顺序', trigger: 'blur'},
              {type: 'integer', message: '请输入整数', trigger: 'blur'},
            ],
            precision: 0, // 整数
            step: 1, // 步长为1
          },
          {
            label: '开始时间',
            prop: 'startTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 120,
            readonly: true, // 设置为只读，通过选择作业编号带出
            change: this.calculateTotalSeconds // 添加change事件
          },
          {
            label: '结束时间',
            prop: 'endTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 120,
            readonly: true, // 设置为只读，通过选择作业编号带出
            change: this.calculateTotalSeconds // 添加change事件
          },
          {
            label: '环节耗时(秒)',
            prop: 'durationSeconds',
            type: 'number',
            precision: 0, // 整数
            step: 1, // 步长为1
            disabled: true, // 设置为只读
            value: 0 // 默认值0
          },
          {
            label: '是否正常',
            prop: 'isNormal',
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=is_normal",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择是否正常', trigger: 'change'}
            ],
            value: 1
          },
          {
            label: '备注',
            prop: 'remark',
            maxlength: 50,
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: true,
            search: false, // 不参与查询
            rules: [
              {max: 50, message: '备注不能超过50个字符', trigger: 'blur'}
            ]
          },
          {
            label: "指令类型",
            prop: "commandType",
            type: 'select',
            overHidden: true,
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=command_type",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择指令类型', trigger: 'change'}
            ],
          },
          {
            label: '指令触发时间',
            prop: 'commandTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 180,
            value: this.getCurrentDateTimeString(),
            hide:true
          },
          {
            label: "是否超时",
            prop: "is_overtime",
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=is_overtime",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择是否超时', trigger: 'change'}
            ],
            value: 0
          },
          {
            label: '超时秒数(秒)',
            prop: 'overtimeSeconds',
            type: 'number',
            precision: 0, // 整数
            step: 1, // 步长为1
            value: 0 // 默认值0
          },
          {
            label: '标准耗时(秒)',
            prop: 'standardSeconds',
            type: 'number',
            precision: 0, // 整数
            step: 1, // 步长为1
            value: 0, // 默认值0
            hide:true
          },
          {
            label: "状态",
            prop: "status",
            type: 'select',
            overHidden: true,
            search: false,
            hide:true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=status_flag",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择状态', trigger: 'change'}
            ],
            value: 1
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
            search: false,
          },
        ]
      },
    }
  },
  methods: {
    /**
     * 计算环节耗时（秒）
     * 总耗时 = 结束时间 - 开始时间（单位：秒）
     */
    calculateTotalSeconds() {
      // 确保两个时间字段都有值
      if (this.form.startTime && this.form.endTime) {
        try {
          const start = new Date(this.form.startTime);
          const end = new Date(this.form.endTime);
          // 验证时间有效性
          if (isNaN(start.getTime()) || isNaN(end.getTime())) {
            this.form.durationSeconds = 0;
            return;
          }
          // 计算时间差（毫秒）并转换为秒
          const diffMs = end.getTime() - start.getTime();
          // 确保结束时间不早于开始时间
          if (diffMs < 0) {
            this.form.durationSeconds = 0;
            // 可以添加错误提示
            this.$message.warning('结束时间不能早于开始时间');
            return;
          }
          // 转换为秒并取整
          this.form.durationSeconds = Math.round(diffMs / 1000);
        } catch (error) {
          console.error('计算环节耗时失败:', error);
          this.form.durationSeconds = 0;
        }
      } else {
        // 如果任一时间为空，设置环节耗时为0
        this.form.durationSeconds = 0;
      }
    },

    /**
     * 在打开对话框前设置默认值
     */
    beforeOpen(done, type) {
      if (type === 'add') {
        // 新增时设置默认值
        this.$nextTick(() => {
          this.form.status = 1;
          this.form.durationSeconds = 0; // 设置环节耗时默认值
          this.form.commandTime = this.getCurrentDateTimeString();
        });
      }
      done();
    },
    /**
     * 从选择组件接收数据并赋值给表单
     * @param {Object} row - 选择的行数据
     */
    replace(row) {
      // 定义需要替换的字段
      const replaceKeys = ['operationNo', 'startTime', 'endTime'];
      // 遍历字段并设置值
      replaceKeys.forEach(key => {
        if (row[key] !== undefined && row[key] !== null) {
          this.$set(this.form, key, row[key]);
        }
      });
      // 自动计算环节耗时
      this.$nextTick(() => {
        this.calculateTotalSeconds();
      });
    },
    /**
     * 获取当前日期时间的字符串（yyyy-MM-dd HH:mm:ss格式）
     */
    getCurrentDateTimeString() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
  },
  watch: {
    // 监听开始时间和结束时间的变化，确保实时计算
    'form.startTime': {
      handler() {
        this.calculateTotalSeconds();
      }
    },
    'form.endTime': {
      handler() {
        this.calculateTotalSeconds();
      }
    }
  }
}
</script>
<style scoped lang="scss">
</style>
